export const namespace = 'birthYearQuestion';